(() => {
  document.querySelectorAll('[data-ck-lightbox]').forEach((root) => {
    const dialog = root.querySelector('[data-ck-lightbox-dialog]');
    if (!dialog) return;
    const img = dialog.querySelector('img');
    const caption = dialog.querySelector('p');
    const slides = Array.from(root.querySelectorAll('[data-ck-lightbox-open][data-src]'));
    let index = 0;

    function close() {
      dialog.classList.add('ck-hidden');
      dialog.hidden = true;
      document.body.classList.remove('ck-lightbox-open');
    }

    function show(nextIndex) {
      if (!slides.length) return;
      index = (nextIndex + slides.length) % slides.length;
      const slide = slides[index];
      const src = slide.getAttribute('data-src');
      const name = slide.getAttribute('data-name') || '';
      img.removeAttribute('width');
      img.removeAttribute('height');
      img.src = src;
      img.alt = name;
      caption.textContent = name;
    }

    function open(btn) {
      const start = slides.indexOf(btn);
      if (start < 0) return;
      show(start);
      dialog.classList.remove('ck-hidden');
      dialog.hidden = false;
      document.body.classList.add('ck-lightbox-open');
    }

    slides.forEach((btn) => {
      btn.addEventListener('click', () => open(btn));
    });
    dialog.querySelectorAll('[data-ck-lightbox-close]').forEach((btn) => {
      btn.addEventListener('click', close);
    });
    dialog.querySelector('[data-ck-lightbox-prev]')?.addEventListener('click', () => show(index - 1));
    dialog.querySelector('[data-ck-lightbox-next]')?.addEventListener('click', () => show(index + 1));
    document.addEventListener('keydown', (event) => {
      if (dialog.hidden) return;
      if (event.key === 'Escape') close();
      if (event.key === 'ArrowLeft') show(index - 1);
      if (event.key === 'ArrowRight') show(index + 1);
    });

    let touchX = 0;
    let touchY = 0;
    const stage = dialog.querySelector('.ck-lightbox__stage') || dialog;
    stage.addEventListener(
      'touchstart',
      (event) => {
        const touch = event.changedTouches[0];
        touchX = touch.clientX;
        touchY = touch.clientY;
      },
      { passive: true },
    );
    stage.addEventListener(
      'touchend',
      (event) => {
        if (dialog.hidden) return;
        const touch = event.changedTouches[0];
        const dx = touch.clientX - touchX;
        const dy = touch.clientY - touchY;
        if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
        show(dx < 0 ? index + 1 : index - 1);
      },
      { passive: true },
    );
  });
})();
